// Creative Vibes — Main JS (real Shopify cart)

// ── i18n (strings injected by layout/theme.liquid as window.CV_I18N) ──
var CV_T = window.CV_I18N || {};
function cvT(key, fallback){ return (CV_T && CV_T[key]) ? CV_T[key] : fallback; }

// ── DYNAMIC HEADER SPACER ──
function syncSpacer() {
  var hdr = document.getElementById('cv-header-fixed');
  var spacer = document.getElementById('cv-header-spacer');
  if (hdr && spacer) {
    spacer.style.height = hdr.offsetHeight + 'px';
    document.documentElement.style.setProperty('--header-h', hdr.offsetHeight + 'px');
  }
}
syncSpacer();
window.addEventListener('resize', syncSpacer);
window.addEventListener('load', syncSpacer);

// ── NAV SCROLL EFFECT ──
var nav = document.getElementById('cv-nav');
if (nav) {
  window.addEventListener('scroll', function () {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  });
}

// ── MOBILE MENU TOGGLE ──
function cvToggleMenu(){
  var links = document.querySelector('.cv-nav-links');
  if(links) links.classList.toggle('open');
}
window.cvToggleMenu = cvToggleMenu;

// ── SEARCH BAR TOGGLE ──
function cvToggleSearch(){
  var bar = document.getElementById('cvSearchBar');
  if(!bar) return;
  bar.classList.toggle('open');
  if(bar.classList.contains('open')){
    var input = document.getElementById('cvSearchBarInput');
    if(input) setTimeout(function(){ input.focus(); }, 120);
  }
}
window.cvToggleSearch = cvToggleSearch;

// ── SCROLL REVEALS ──
var obs = new IntersectionObserver(function(entries){
  entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('vis'); });
},{ threshold:0.06, rootMargin:'0px 0px -40px 0px' });
document.querySelectorAll('.reveal').forEach(function(el){ obs.observe(el); });

// ── TOAST ──
function cvShowToast(msg){
  var t=document.getElementById('toast');
  if(!t) return;
  t.textContent=msg; t.classList.add('show');
  setTimeout(function(){ t.classList.remove('show'); },2400);
}
window.cvShowToast = cvShowToast;

// ───────────────────
// REAL SHOPIFY CART (Cart AJAX API)
// ───────────────────
var CV_FREE_SHIP = 20000; // AED 200 in cents

function cvMoney(cents){ return (cents/100).toLocaleString(undefined,{minimumFractionDigits:0,maximumFractionDigits:2}) + ' AED'; }

function cvRenderShipBar(totalCents){
  var wrap=document.getElementById('cvShipBar');
  if(!wrap) return;
  var pct = Math.min(100, Math.round((totalCents/CV_FREE_SHIP)*100));
  var fill=document.getElementById('cvShipFill');
  var msg=document.getElementById('cvShipMsg');
  if(fill) fill.style.width = pct + '%';
  if(msg){
    if(totalCents <= 0){
      wrap.classList.remove('cv-ship-done');
      msg.innerHTML = cvT('spend','Spend') + ' ' + cvMoney(CV_FREE_SHIP) + ' ' + cvT('to_unlock','to unlock') + ' <strong>' + cvT('free_ww','free worldwide delivery') + '</strong>';
    } else if(totalCents >= CV_FREE_SHIP){
      msg.innerHTML = '✦ ' + cvT('unlocked','You’ve unlocked') + ' <strong>' + cvT('free_ww_bang','free worldwide delivery!') + '</strong>';
      wrap.classList.add('cv-ship-done');
    } else {
      var remain = CV_FREE_SHIP - totalCents;
      msg.innerHTML = cvT('youre','You’re') + ' ' + cvMoney(remain) + ' ' + cvT('away_from','away from') + ' <strong>' + cvT('free_delivery','free delivery') + '</strong>';
      wrap.classList.remove('cv-ship-done');
    }
  }
}

function cvRenderCart(cart){
  var count=document.getElementById('cvCartCount');
  var body=document.getElementById('cvCartBody');
  var total=document.getElementById('cvCartTotal');
  if(count){ count.textContent=cart.item_count; count.classList.toggle('show', cart.item_count>0); }
  if(total) total.textContent=cvMoney(cart.total_price);
  cvRenderShipBar(cart.total_price);
  if(!body) return;
  if(!cart.items || !cart.items.length){
    body.innerHTML='<div class="cv-cart-empty"><div style="font-size:32px;margin-bottom:12px;">✦</div><p style="font-family:var(--font-head);font-size:18px;font-style:italic;color:#9B7AAA;">'+cvT('empty','Your cart is empty.')+'</p></div>';
    return;
  }
  body.innerHTML=cart.items.map(function(item){
    var img = item.image ? '<img src="'+item.image+'" alt="" style="width:100%;height:100%;object-fit:cover;">' : '';
    return '<div class="cv-cart-item"><div class="cv-ci-img">'+img+'</div><div class="cv-ci-info"><div class="cv-ci-name">'+item.product_title+'</div><div class="cv-ci-variant">'+(item.variant_title||'')+' · '+cvT('qty','Qty')+' '+item.quantity+'</div><div class="cv-ci-price">'+cvMoney(item.final_line_price)+'</div><button class="cv-ci-remove" data-key="'+item.key+'">'+cvT('remove','Remove')+'</button></div></div>';
  }).join('');
  body.querySelectorAll('.cv-ci-remove').forEach(function(b){
    b.addEventListener('click',function(){ cvChangeItem(b.getAttribute('data-key'),0); });
  });
}

function cvFetchCart(){
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(cvRenderCart).catch(function(){});
}

function cvChangeItem(key,qty){
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(cvRenderCart).catch(function(){});
}
window.cvChangeItem = cvChangeItem;

function cvAddVariant(variantId, qty){
  return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:variantId,quantity:qty||1})})
    .then(function(r){ if(!r.ok) return r.json().then(function(e){throw e;}); return r.json(); })
    .then(function(){ cvFetchCart(); cvOpenCart(); cvShowToast(cvT('added','Added to cart ✦')); })
    .catch(function(err){ cvShowToast((err&&err.description)||cvT('add_error','Could not add item')); });
}
window.cvAddVariant = cvAddVariant;

function cvOpenCart(){ var p=document.getElementById('cvCartPanel'),o=document.getElementById('cvCartOverlay'); if(p)p.classList.add('open'); if(o)o.classList.add('show'); }
window.cvOpenCart=cvOpenCart;
function cvCloseCart(){ var p=document.getElementById('cvCartPanel'),o=document.getElementById('cvCartOverlay'); if(p)p.classList.remove('open'); if(o)o.classList.remove('show'); }
window.cvCloseCart=cvCloseCart;

// Product-page form → AJAX add (keeps user on page, opens slide-out)
var pform=document.getElementById('cv-product-form');
if(pform){
  pform.addEventListener('submit',function(e){
    e.preventDefault();
    var idField=pform.querySelector('[name="id"]');
    var qtyField=pform.querySelector('[name="quantity"]');
    var qty = qtyField ? parseInt(qtyField.value,10)||1 : 1;
    if(idField){ cvAddVariant(idField.value, qty); }
  });
}

// Quantity stepper (product page)
function cvQty(delta){
  var input=document.getElementById('cvQtyInput');
  if(!input) return;
  var v=parseInt(input.value,10)||1;
  v=Math.max(1, v+delta);
  input.value=v;
}
window.cvQty = cvQty;

// Filter button active state (homepage)
document.querySelectorAll('.cv-f-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    document.querySelectorAll('.cv-f-btn').forEach(function(b){b.classList.remove('active');});
    btn.classList.add('active');
  });
});

// Init
cvFetchCart();
